import { Component, OnInit } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { select, Store } from '@ngrx/store'
import { selectAllRentals } from '@tokeet-frontend/tv3-platform'
import { FormBuilder, Validators } from '@angular/forms'
import * as fromState from '@tv3/store/state'
import { Toaster } from '@tokeet-frontend/tv3-platform'
import { AuthService } from '@tv3/services/auth.service'
import { filter, startWith, take } from 'rxjs/operators'
import { WebsiteService } from '@tv3/store/website/website.service'
import { widgetFontFamilies } from '@tv3/containers/widgets/shared/constants/font-families'
import { Rental } from '@tokeet-frontend/tv3-platform'
import * as R from 'ramda'
import { isSomething } from '@tokeet-frontend/tv3-platform'
import { AmplitudeService } from '@tv3/services/amplitude.service'

@Component({
  selector: 'app-booking-widget',
  templateUrl: './booking-widget.component.html',
  styleUrls: ['./booking-widget.component.scss'],
})
export class BookingWidgetComponent implements OnInit {
  widgetType: 'simple' | 'extended' | 'extendedwide' = 'simple'
  widgetCode = ''
  trustedWidgetCode: SafeHtml

  rentals: Rental[] = []
  filteredRentals: Rental[] = []
  websiteEngines$ = this.websiteService.allEngines()
  fontSizeOpts = [12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24]
  fontFamilies = widgetFontFamilies
  orientationOpts = ['vertical', 'horizontal']

  form = this.fb.group({
    rentalId: [],
    engine: [],
    background: ['#F8F8F8', [Validators.required]],
    button_bg: ['#00bcd3', [Validators.required]],
    button_fg: ['#FFF', [Validators.required]],
    blocked_bg: ['#b63e3e', [Validators.required]],
    label_fg: ['#00bcd3', [Validators.required]],
    selected_bg: ['#299082', [Validators.required]],
    selected_fg: ['#FFF', [Validators.required]],
    asterisk_bg: ['#FABC3C', [Validators.required]],
    font: ['Arial', [Validators.required]],
    label_px: [14, [Validators.required]],
    orientation: ['vertical', [Validators.required]],
    showChildren: [true],
    sundayFirst: [true, [Validators.required]],
    width: [350, [Validators.required]],
  })

  constructor(
    private store: Store<fromState.State>,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private toast: Toaster,
    private websiteService: WebsiteService,
    private auth: AuthService,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit() {
    this.form.valueChanges.pipe(startWith(this.form.getRawValue())).subscribe((config) => {
      if (config.engine) {
        this.filteredRentals = R.filter(
          (r) => R.pathOr([], ['rentals'], config.engine).indexOf(r.id) > -1,
          this.rentals
        )
      }
      if (config.rentalId && !R.find((r) => r.id === config.rentalId, this.filteredRentals)) {
        this.form.patchValue({ rentalId: undefined })
        config.rentalId = undefined
      }
      this.buildCode(this.widgetType, config)
    })

    this.store
      .pipe(
        select(selectAllRentals),
        filter((rentals) => isSomething(rentals)),
        take(1)
      )
      .subscribe((rentals) => {
        this.rentals = rentals
      })
  }

  buildCode(type, config) {
    if (!config.rentalId || !config.engine) {
      return
    }
    this.widgetCode = `<div style="width:${config.width}px"
        data-website-id="${config.engine.pkey}"
        data-tokeet-widget="booking"
        data-booking-domain="https://${config.engine.domain}"
        data-account-id="${this.auth.user.account}"
        data-rental-id="${config.rentalId}"
        data-orientation="${config.orientation}"
        data-show-children="${config.showChildren !== false}"
        data-style-widget-background="${config.background}"
        data-style-button-bg="${config.button_bg}"
        data-style-button-color="${config.button_fg}"
        data-style-label-color="${config.label_fg}"
        data-style-label-size="${config.label_px}"
        data-date-format="DD-MM-YYYY"
        data-style-blocked-dates-bg="${config.blocked_bg}"
        data-style-selected-dates-bg="${config.selected_bg}"
        data-style-selected-dates-color="${config.selected_fg}"
        data-booking-widget-css=".booking-widget { font-family: ${config.font} }
          .label.required:after{ color: ${config.asterisk_bg}; }"
        class="booking-widget"></div>
        <script data-tokeet-widget-loader="booking" async
        src="https://s3.amazonaws.com/widgets.tokeet.com/widgets/booking/widget-loader.js"></script>`

    this.trustedWidgetCode = this.sanitizer.bypassSecurityTrustHtml(this.widgetCode)
  }

  onCopied($event) {
    this.toast.success($localize`Code copied.`)
    this.amplitudeService.logEvent('widget-booking-copied')
  }

  onColorSelected(key, color) {
    this.form.patchValue({ [key]: color })
  }
}
